var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { asEnum } from "healthex-common/utils";
import { PatientImportMethod } from "healthex-common/study.dtos";
import { UserType } from "healthex-common/user.dtos";
import { computed } from "mobx";
import { NamedRoutes } from "../NamedRoutes";
import { findMatchingNamedRouteParent } from "../RoutingUIManager";
export class AddPatientsUIManager {
    constructor(routingUIManager, authManager) {
        this.routingUIManager = routingUIManager;
        this.authManager = authManager;
        this.routingUIManager.registerRedirect(NamedRoutes.PROJECTS_ADD_PATIENTS_METHOD, (routeParams) => {
            const method = this.getMethodFromRouteParams(routeParams.method);
            const projectId = routeParams === null || routeParams === void 0 ? void 0 : routeParams.projectId;
            if (this.authManager.userType !== UserType.EXTERNAL_RESEARCHER) {
                if (projectId) {
                    return {
                        route: NamedRoutes.PROJECTS_PROJECT_MANAGER_PATIENT_MANAGEMENT,
                        routeParams: { projectId },
                    };
                }
                return { route: NamedRoutes.PROJECTS, routeParams: {} };
            }
            if (routeParams.method && !method && projectId) {
                return { route: NamedRoutes.PROJECTS, routeParams: {} };
            }
            return null;
        });
    }
    get isRelevantRoute() {
        return !!findMatchingNamedRouteParent(this.routingUIManager.currentRoute, [NamedRoutes.PROJECTS_ADD_PATIENTS_METHOD]);
    }
    get projectId() {
        var _a;
        return this.isRelevantRoute ? (_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.projectId : undefined;
    }
    get method() {
        var _a;
        if (!this.isRelevantRoute)
            return null;
        const rawMethod = (_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.method;
        return this.getMethodFromRouteParams(rawMethod);
    }
    getMethodFromRouteParams(rawMethod) {
        if (!rawMethod)
            return null;
        const method = asEnum(PatientImportMethod)(rawMethod.toUpperCase());
        if (method === PatientImportMethod.MANUAL || method === PatientImportMethod.FILE) {
            return method;
        }
        return null;
    }
}
__decorate([
    computed
], AddPatientsUIManager.prototype, "isRelevantRoute", null);
__decorate([
    computed
], AddPatientsUIManager.prototype, "projectId", null);
__decorate([
    computed
], AddPatientsUIManager.prototype, "method", null);
